var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { AddingFunds } from './AddingFunds.js';
import { RampInstantSDK } from '@ramp-network/ramp-instant-sdk';
import { OnRampProvider, getPortalBaseURL, getProviderAssetInverse, getProviderNetworkAndAssetCode, } from '@usecapsule/web-sdk';
import { useCapsuleStore, useModalStore, useThemeStore } from '../../stores/index.js';
import { useGoBack } from '../../hooks/useGoBack.js';
export const RampEmbed = ({ hostApiKey }) => {
    const appName = useThemeStore(state => state.appName);
    const onRampConfig = useModalStore(state => state.onRampConfig);
    const onRampPurchase = useModalStore(state => state.onRampPurchase);
    const setOnRampPurchase = useModalStore(state => state.setOnRampPurchase);
    const capsule = useCapsuleStore(state => state.capsule);
    const goBack = useGoBack();
    const [walletId] = useState(capsule.currentWalletIds[0]);
    useEffect(() => {
        const defaultAsset = getProviderNetworkAndAssetCode(onRampConfig.network, onRampConfig.asset, OnRampProvider.RAMP, onRampConfig.testMode)[0];
        const widget = new RampInstantSDK({
            hostAppName: appName,
            defaultAsset,
            hostLogoUrl: `${getPortalBaseURL(capsule.ctx)}/wordmark_black.svg`,
            hostApiKey,
            userAddress: capsule.getDisplayAddress(walletId),
            userEmailAddress: capsule.getEmail(),
            url: (onRampConfig === null || onRampConfig === void 0 ? void 0 : onRampConfig.testMode) ? 'https://app.demo.ramp.network' : 'https://app.ramp.network',
            enabledFlows: ['ONRAMP'],
        })
            .on('PURCHASE_CREATED', (e) => __awaiter(void 0, void 0, void 0, function* () {
            const p = e.payload.purchase;
            const updated = yield capsule.updateOnRampPurchase(onRampPurchase.walletId, onRampPurchase.id, {
                providerKey: p.id,
                fiatQuantity: p.fiatValue,
                fiatCurrency: p.fiatCurrency,
                asset: getProviderAssetInverse(OnRampProvider.RAMP, p.asset.symbol),
                assetQuantity: p.cryptoAmount,
            });
            setOnRampPurchase(updated);
        }))
            .on('WIDGET_CLOSE', () => __awaiter(void 0, void 0, void 0, function* () {
            goBack();
        }));
        widget.show();
        widget.domNodes.overlay.style.zIndex = '2147483647';
    }, []);
    return _jsx(AddingFunds, {});
};
